import CircleQr from '~/assets/icons/shape/circle.svg?react';
import CloverQr from '~/assets/icons/shape/clover.svg?react';
import CrossQr from '~/assets/icons/shape/cross.svg?react';
import CrossRotatedQr from '~/assets/icons/shape/cross-rotated.svg?react';
import CrossRoundedQr from '~/assets/icons/shape/cross-rounded.svg?react';
import DiamondQr from '~/assets/icons/shape/diamond.svg?react';
import FourCornersStarQr from '~/assets/icons/shape/four-corners-star.svg?react';
import HeartQr from '~/assets/icons/shape/heart.svg?react';
import HorizontalBarsQr from '~/assets/icons/shape/horizontal-bars.svg?react';
import SnakeRevertQr from '~/assets/icons/shape/revert-snake.svg?react';
import RoundedQr_1 from '~/assets/icons/shape/rounded-1.svg?react';
import RoundedQr_2 from '~/assets/icons/shape/rounded-2.svg?react';
import RoundedQr_3 from '~/assets/icons/shape/rounded-3.svg?react';
import RoundedQr_4 from '~/assets/icons/shape/rounded-4.svg?react';
import SnakeQr from '~/assets/icons/shape/snake.svg?react';
import SquareQr from '~/assets/icons/shape/square.svg?react';
import StarQr from '~/assets/icons/shape/star.svg?react';
import TiltedSquareQr from '~/assets/icons/shape/tilted-square.svg?react';
import VerticalBarQr from '~/assets/icons/shape/vertical-bars.svg?react';

// TODO should be deleted
export const shapeQrList = [
  {
    icon: <SquareQr />,
    id: 'square',
    index: 0,
  },
  {
    icon: <RoundedQr_1 />,
    id: 'rounded-1',
    index: 1,
  },
  {
    icon: <RoundedQr_2 />,
    id: 'rounded-2',
    index: 2,
  },
  {
    icon: <CircleQr />,
    id: 'circle',
    index: 3,
  },
  {
    icon: <RoundedQr_3 />,
    id: 'rounded-3',
    index: 4,
  },
  {
    icon: <RoundedQr_4 />,
    id: 'rounded-4',
    index: 5,
  },
  {
    icon: <HorizontalBarsQr />,
    id: 'horizontal-bars',
    index: 6,
  },
  {
    icon: <VerticalBarQr />,
    id: 'vertical-bars',
    index: 7,
  },
  {
    icon: <SnakeQr />,
    id: 'snake',
    index: 8,
  },
  {
    icon: <SnakeRevertQr />,
    id: 'revert-snake',
    index: 9,
  },
  {
    icon: <StarQr />,
    id: 'star',
    index: 10,
  },
  {
    icon: <DiamondQr />,
    id: 'diamond',
    index: 11,
  },
  {
    icon: <CrossRotatedQr />,
    id: 'cross-rotated',
    index: 12,
  },
  {
    icon: <CloverQr />,
    id: 'clover',
    index: 13,
  },
  {
    icon: <CrossQr />,
    id: 'cross',
    index: 14,
  },
  {
    icon: <CrossRoundedQr />,
    id: 'cross-rounded',
    index: 15,
  },
  {
    icon: <HeartQr />,
    id: 'heart',
    index: 16,
  },
  {
    icon: <FourCornersStarQr />,
    id: 'four-corners-star',
    index: 17,
  },
  {
    icon: <TiltedSquareQr />,
    id: 'tilted-square',
    index: 18,
  },
];

export const ShapeQrList = [
  {
    Icon: SquareQr,
    id: 'square',
  },
  {
    Icon: RoundedQr_1,
    id: 'rounded-1',
  },
  {
    Icon: RoundedQr_2,
    id: 'rounded-2',
  },
  {
    Icon: CircleQr,
    id: 'circle',
  },
  {
    Icon: RoundedQr_3,
    id: 'rounded-3',
  },
  {
    Icon: RoundedQr_4,
    id: 'rounded-4',
  },
  {
    Icon: HorizontalBarsQr,
    id: 'horizontal-bars',
  },
  {
    Icon: VerticalBarQr,
    id: 'vertical-bars',
  },
  {
    Icon: SnakeQr,
    id: 'snake',
  },
  {
    Icon: SnakeRevertQr,
    id: 'revert-snake',
  },
  {
    Icon: StarQr,
    id: 'star',
  },
  {
    Icon: DiamondQr,
    id: 'diamond',
  },
  {
    Icon: CrossRotatedQr,
    id: 'cross-rotated',
  },
  {
    Icon: CloverQr,
    id: 'clover',
  },
  {
    Icon: CrossQr,
    id: 'cross',
  },
  {
    Icon: CrossRoundedQr,
    id: 'cross-rounded',
  },
  {
    Icon: HeartQr,
    id: 'heart',
  },
  {
    Icon: FourCornersStarQr,
    id: 'four-corners-star',
  },
  {
    Icon: TiltedSquareQr,
    id: 'tilted-square',
  },
];
